import PropTypes from "prop-types";

import { alignItems, strCode } from "../../../../consts";
import { t } from "../../../../services";
import { withSection } from "../../../../hoc";

import { Heading6 } from "../../../Text/Headings";
import WrapperContainer from "../../../Containers/WrapperContainer";
import FlexContainers from "../../../Containers/FlexContainers";
import { Paragraph2 } from "../../../Text/Paragraphs";
import { Button } from "../../../Buttons/styled";

import { TableExampleWrapper } from "./styled";

const TableExample = ({ fileName, fileUrl }) => {
  const onDownloadExample = () => {
    const link = document.createElement("a");
    link.download = `${fileName}.csv`;
    link.href = fileUrl;
    link.click();
  };

  return (
    <TableExampleWrapper width={"100%"}>
      <Heading6>{t(strCode.TABLE_EXAMPLE_TITLE)}</Heading6>

      <WrapperContainer
        Container={FlexContainers.FlexRowBetween}
        alignItems={alignItems.start}
        width={"100%"}>
        <Paragraph2>{t(strCode.TABLE_EXAMPLE_INFO)} </Paragraph2>

        <Button secondary onClick={onDownloadExample}>
          {t(strCode.DOWNLOAD_BTN)}
        </Button>
      </WrapperContainer>
    </TableExampleWrapper>
  );
};

TableExample.propTypes = {
  fileName: PropTypes.string.isRequired,
  fileUrl: PropTypes.string.isRequired
};

export default withSection(TableExample);
